export const demoUser = {
  id: 1,
  survivorId: "S-04112",
  name: "한서진",
  role: "정찰대 기록관",
  camp: "GB-33-A",
  clearance: 3,
  condition: "정상",
  bloodType: "O+",
  lastSeenAt: "2026-10-13 02:41",
};

export const demoDashboard = {
  network: {
    status: "불안정",
    latency: "318ms",
    activeNodes: 7,
    lastSyncAt: "2026-10-13 03:11",
  },
  stats: [
    { label: "확인 생존자", value: "4,112", unit: "명", delta: "-443", tone: "red" },
    { label: "캠프 전력", value: "63", unit: "%", delta: "11시간", tone: "green" },
    { label: "식량 잔량", value: "8", unit: "일", delta: "배급 2단계", tone: "amber" },
    { label: "위험 신호", value: "12", unit: "건", delta: "+4", tone: "red" },
  ],
  alerts: [
    {
      id: 1,
      level: "CRITICAL",
      title: "북동쪽 방벽 움직임 감지",
      message: "3번 감시탑에서 대형 개체 2기를 확인했습니다. 비전투 인원은 지하 구역으로 이동하십시오.",
      area: "GB-33-A / 북동 방벽",
      createdAt: "03:04",
    },
    {
      id: 2,
      level: "WARNING",
      title: "정수 설비 출력 저하",
      message: "B계통 필터 오염률이 81%입니다. 금일 18시부터 개인 급수를 제한합니다.",
      area: "생활 구역 / 정수실",
      createdAt: "02:32",
    },
  ],
  news: [
    {
      id: 1,
      category: "정찰 보고",
      title: "청송 외곽에서 버터플라이 개체 재확인",
      summary: "기존 기록보다 넓은 활동 반경이 확인되었습니다. 야외 이동 시 상부 구조물을 확보하십시오.",
      body: "13일 01시 20분, 청송 외곽 폐주유소 상공에서 버터플라이 성체 두 마리가 확인되었습니다. 기존 관찰 지점으로부터 18km 떨어진 위치로 활동 반경이 확대된 것으로 판단됩니다. 야간 이동조는 개방된 도로를 피하고 지하 통로를 우선 이용하십시오.",
      author: "정찰 2조",
      createdAt: "26분 전",
    },
    {
      id: 2,
      category: "중앙 공지",
      title: "금일 통신 가능 시간 변경",
      summary: "중계기 과열로 원거리 송수신 가능 시간이 21시부터 23시까지로 변경됩니다.",
      body: "중앙 중계기 냉각 계통의 출력이 불안정합니다. 원거리 교신은 21시부터 23시 사이에만 허용됩니다. 긴급 구조 신호는 시간 제한 없이 수신하지만 회신이 지연될 수 있습니다.",
      author: "통신 통제실",
      createdAt: "1시간 전",
    },
    {
      id: 3,
      category: "보급",
      title: "남부 창고 의약품 목록 갱신",
      summary: "항생제 18회분과 수액 7팩이 입고되었습니다. 의료반 승인 후 수령할 수 있습니다.",
      body: "남부 보급로를 통해 회수한 의료 물자가 검수 완료되었습니다. 감염 의심자에게 우선 배정하며 무단 반출 시 보안 등급이 즉시 회수됩니다.",
      author: "보급 관리실",
      createdAt: "3시간 전",
    },
  ],
};

export const demoCrops = [
  {
    id: 1,
    code: "CRP-01",
    name: "버터플라이",
    level: 4,
    status: "위기 (EN)",
    habitat: "산악·폐도심 상공",
    size: "높이 0.8m / 익폭 2.3m",
    encounterCount: 17,
    description: "2024년 10월 22일 대한민국 경상북도 청송군 GB-33-A 생존자 캠프에서 최초 목격되었습니다. 곤충의 외형을 하고 있으며 독수리와 같은 크기를 가지고 있습니다. 나비와 비슷한 입으로 두부를 관통해 체액을 섭취하며, 생물의 뇌를 특이하게 좋아하는 것으로 보입니다. 타 개체와도 적대적인 성향을 보이므로 전략적으로 사용한다면 캠프 방어에 효과적일 것으로 확인됩니다.",
    weakness: "관통 무기, 외골격 파괴 후 화염",
    protocol: "개체가 출입할 수 없는 깊고 좁은 곳으로 대피하십시오. 입 길이는 최대 2m이므로 닿지 않을 거리를 유지해야 합니다. 약 1.5cm 두께의 외골격 때문에 둔기로는 제압할 수 없습니다. 유리, 칼, 창, 화살, 총 등의 관통 무기가 유효하며 외골격이 파괴된 뒤에는 화염이 효과적입니다.",
    lastSeen: "청송군 외곽 / 26분 전",
  },
  {
    id: 2,
    code: "CRP-07",
    name: "리피터",
    level: 6,
    status: "위급 (CR)",
    habitat: "지하 시설·통신소",
    size: "신장 1.9~2.4m",
    encounterCount: 8,
    description: "인간의 목소리와 무전 신호를 재현해 구조 인원을 유인하는 개체.",
    weakness: "고주파 교란, 강한 섬광",
    protocol: "음성 구조 신호에 응답하지 말고 지정된 암호문을 요구한다.",
    lastSeen: "수도권 8번 중계소 / 2일 전",
  },
  {
    id: 3,
    code: "CRP-12",
    name: "모스",
    level: 2,
    status: "준위협 (NT)",
    habitat: "습한 지하·식량 창고",
    size: "군집형 / 개체 8~15cm",
    encounterCount: 31,
    description: "균사 형태로 번식하며 장기간 노출된 생물의 신경계를 둔화시킨다.",
    weakness: "건조 환경, 염소계 소독제",
    protocol: "보호구 없이 포자 구역에 진입하지 말고 오염 식량은 즉시 소각한다.",
    lastSeen: "GB-33-A 남부 창고 / 6시간 전",
  },
  {
    id: 4,
    code: "CRP-19",
    name: "웨이크",
    level: 7,
    status: "정보부족 (DD)",
    habitat: "해안·수몰 지역",
    size: "추정 9m 이상",
    encounterCount: 2,
    description: "수면 아래에서 진동을 추적한다. 확인된 생존 사례가 거의 없다.",
    weakness: "미확인",
    protocol: "해안선 3km 이내 접근을 전면 금지한다.",
    lastSeen: "부산 북항 / 19일 전",
  },
];

export const demoPosts = [
  { id: 1, type: "구조 요청", title: "의료 인력 지원 요청", content: "동부 대피소에 골절 환자 2명이 있습니다.", author: "E-12 감시조", createdAt: "18분 전", urgent: true },
  { id: 2, type: "물자 교환", title: "건전지와 정수 알약 교환", content: "AA 건전지 12개를 정수 알약과 교환합니다.", author: "박도윤", createdAt: "47분 전", urgent: false },
  { id: 3, type: "실종자", title: "정찰대원 최민규 수색", content: "어제 22시 이후 무전 두절. 마지막 위치는 4번 터널입니다.", author: "정찰 1조", createdAt: "2시간 전", urgent: true },
];
